<form [formGroup]="roleAdminSearchForm">
    <div class="ontario-form-group">
      <input type="hidden" name="menuType" id="menuType" value="secure" />      
  
      <div class="ontario-row">
        <div class="ontario-columns">
          <h3 id="pageTitle"> {{'bss.roleAdminSearch.title' | translate }} 
          </h3>  
          <hr>   
        </div>
      </div>  

      <div class="ontario-row">
        <div class="ontario-column ontario-small-12">
          <div *ngIf="(submitted || onRolesLoad) && appError" class="ontario-alert ontario-alert--error" aria-live="polite"
            aria-atomic="true" id="pageLevelMessageId" #pageMsg>
            <div class="ontario-alert__header">
              <div class="ontario-alert__header-icon">
                <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false" sol:category="primary"
                  viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                  <use href="#ontario-icon-alert-error"></use>
                </svg>
              </div>
              <h2 class="ontario-alert__header-title ontario-h4">{{'bss.roleAdminSearch.error' | translate }}</h2>
            </div>
            <div class="ontario-alert__body">
              <p [innerHTML]="appErrorMessage | translate">
            </div>
          </div>
        </div>
      </div>

	    <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-3">
                <label class="ontario-label" for="roles">
                  {{'bss.roleAdminSearch.text.manageRoleMembership' | translate }}
                <span class="ontario-label__flag"> ({{'bss.register.required' |
                  translate }})</span>
                  </label> 
              </div>
               
              <div class="ontario-columns ontario-small-12 ontario-medium-9">                  
                  <select tabindex="101" id="managerole" name="managerole" type="dropdown" class="ontario-input ontario-dropdown ontario-input--20-char-width" formControlName="managerole" #managerole (change)="onSelected(managerole.value)" title="{{'bss.roleAdminSearch.dropdown.manageRoleMembership.title' | translate }}">
                    
                    <option disabled value="null">{{'bss.roleAdminSearch.text.selectRole' | translate }} </option>
                    <option *ngFor="let role of currentRolesArray | keyvalue" [value]="role.value">{{ role.value }}</option>
                  </select>            
                 
              <div
              *ngIf="(submitted || roleAdminSearchForm.get('firstName').touched || roleAdminSearchForm.get('lastName').touched || roleAdminSearchForm.get('email').touched || roleAdminSearchForm.get('guid').touched) && (roleAdminSearchForm.get('managerole').value == null)"
              id="roleDropdownError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
              <ul>
                <li>{{'bss.roleAdminSearch.error.roleDropdown.invalid' | translate }} </li>
              </ul>
            </div>
             
          </div>
        </dd></dl>
      </div>	  
      
      <div class="ontario-row">
        <dl><dt></dt><dd class="fractal-dt ontario-padding-bottom-24-!">
          <div class="ontario-columns ontario-small-12 ontario-medium-12">
              {{'bss.roleAdminSearch.text.searchUserAccount' | translate }}
          </div>
        </dd></dl>
    </div>

      <div class="ontario-row">
        <dl><dt></dt><dd>
          <div class="ontario-columns ontario-small-12 ontario-medium-3">
            <label class="ontario-label" for="firstName">
              {{'bss.roleAdminSearch.firstName' | translate }} </label>
          </div>
          <div class="ontario-columns ontario-small-12 ontario-medium-9">
            <input tabindex="102" class="ontario-input ontario-input--20-char-width" type="text" id="firstName"
              title=" {{'bss.roleAdminSearch.firstName.title' | translate }}" formControlName="firstName" aria-describedby="firstNameError">
  
            <div
              *ngIf="(submitted || roleAdminSearchForm.get('firstName').touched || roleAdminSearchForm.get('firstName').dirty) && (roleAdminSearchForm.get('firstName').errors?.['required'])"
              id="firstNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
              <ul>
                <li>{{'bss.roleAdminSearch.error.firstName.required' | translate }} </li>
              </ul>
            </div>
  
            <div
              *ngIf="(submitted || roleAdminSearchForm.get('firstName').touched || roleAdminSearchForm.get('firstName').dirty) && (roleAdminSearchForm.get('firstName').errors?.['pattern']) || (roleAdminSearchForm.get('firstName').errors?.['invalidInputAsterisk'])"
              id="firstNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
              <ul>
                <li *ngIf="(roleAdminSearchForm.get('firstName').errors?.['pattern'])">
                  {{'bss.roleAdminSearch.error.firstName.invalid' | translate }}
                </li>
                <li *ngIf="(roleAdminSearchForm.get('firstName').errors?.['invalidInputAsterisk'])">
                  {{'bss.roleAdminSearch.error.Asterisk' | translate }}
                </li>
              </ul>
            </div>
          </div>
        </dd></dl>
      </div>  
     
      <div class="ontario-row">
        <dl><dt></dt><dd>
          <div class="ontario-columns ontario-small-12 ontario-medium-3">
            <label class="ontario-label" for="lastName">
              {{'bss.roleAdminSearch.lastName' | translate }}
            </label>
          </div>
          <div class="ontario-columns ontario-small-12 ontario-medium-9">
            <input tabindex="103" class="ontario-input ontario-input--20-char-width" type="text" id="lastName"
              aria-describedby="lastNameError" title="{{'bss.roleAdminSearch.lastName.title' | translate }}"
              formControlName="lastName">
  
            <div
              *ngIf="(submitted || roleAdminSearchForm.get('lastName').touched || roleAdminSearchForm.get('lastName').dirty) && (roleAdminSearchForm.get('lastName').errors?.['required'])"
              id="lastNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
              <ul>
                <li>{{'bss.roleAdminSearch.error.lastName.required' | translate }} </li>
              </ul>
            </div>
  
            <div
              *ngIf="(submitted || roleAdminSearchForm.get('lastName').touched || roleAdminSearchForm.get('lastName').dirty) && (roleAdminSearchForm.get('lastName').errors?.['pattern']) || (roleAdminSearchForm.get('lastName').errors?.['invalidInputAsterisk'])"
              id="lastNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
              <ul>
                <li *ngIf="(roleAdminSearchForm.get('lastName').errors?.['pattern'])">
                  {{'bss.roleAdminSearch.error.lastName.invalid' | translate }}
                </li>
                <li *ngIf="(roleAdminSearchForm.get('lastName').errors?.['invalidInputAsterisk'])">
                  {{'bss.roleAdminSearch.error.Asterisk' | translate }}
                </li>
              </ul>
            </div>
          </div>
        </dd></dl>
      </div>      
  
      <div class="ontario-row">
        <dl><dt></dt><dd>
          <div class="ontario-columns ontario-small-12 ontario-medium-3">
            <label class="ontario-label" for="email">
              {{'bss.roleAdminSearch.emailAddress' | translate }} 
            </label>
          </div>
          <div class="ontario-columns ontario-small-12 ontario-medium-9">
            <input tabindex="104" class="ontario-input ontario-input--20-char-width" type="text" id="email"
              aria-describedby="emailError" title="{{'bss.roleAdminSearch.emailAddress.input.title' | translate }}" 
              formControlName="email">
  
            <div id="emailError" role="alert" aria-live="assertive"
              *ngIf="(roleAdminSearchForm.get('email').touched || roleAdminSearchForm.get('email').dirty || submitted) && roleAdminSearchForm.get('email').errors?.['required']"
              class="ontario-alert ontario-alert--error">
              <ul>
                <li>{{'bss.roleAdminSearch.error.email.required' | translate }} </li>
              </ul>
            </div>
            
            <div id="emailError" role="alert" aria-live="assertive"
              *ngIf="roleAdminSearchForm.get('email').touched && (roleAdminSearchForm.get('email')?.hasError('email') ||  roleAdminSearchForm.get('email')?.hasError('invalidEmail')) "
              class="ontario-alert ontario-alert--error">
              <ul>
                <li>{{'bss.roleAdminSearch.error.email.invalid' | translate }} </li>
              </ul>
            </div>
  
            <div id="emailError" role="alert" aria-live="assertive"
              *ngIf="(submitted || roleAdminSearchForm.get('email').touched ||
                      roleAdminSearchForm.get('email').dirty) && ( roleAdminSearchForm.get('email').errors?.['restricted'])"
              class="ontario-alert ontario-alert--error">
              <ul>
                <li>{{'bss.login.err.email.restricted' | translate }} </li>
              </ul>
            </div> 

            <div id="emailError" role="alert" aria-live="assertive"
              *ngIf="(submitted || roleAdminSearchForm.get('email').touched ||
                      roleAdminSearchForm.get('email').dirty) && ( roleAdminSearchForm.get('email').errors?.['invalidInputAsterisk'])"
              class="ontario-alert ontario-alert--error">
              <ul>
                <li>{{'bss.roleAdminSearch.error.Asterisk' | translate }}</li>
              </ul>
            </div> 
            
          </div>
        </dd></dl>
      </div>
	  
	    <div class="ontario-row">
        <dl><dt></dt><dd>
          <div class="ontario-columns ontario-small-12 ontario-medium-3">
            <label class="ontario-label" for="guid">
              {{'bss.roleAdminSearch.GUID' | translate }}
            </label>
          </div>
          <div class="ontario-columns ontario-small-12 ontario-medium-9">
            <input tabindex="105" class="ontario-input ontario-input--20-char-width" type="text" id="guid"
              aria-describedby="GUIDError" title="{{'bss.roleAdminSearch.GUID.input.title' | translate }}"
              formControlName="guid">
  
            <div
              *ngIf="(submitted || roleAdminSearchForm.get('guid').touched || roleAdminSearchForm.get('guid').dirty) && (roleAdminSearchForm.get('guid').errors?.['required'])"
              id="GUIDError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
              <ul>
                <li>{{'bss.roleAdminSearch.error.GUID.required' | translate }} </li>
              </ul>
            </div>
  
            <div
              *ngIf="(submitted || roleAdminSearchForm.get('guid').touched || roleAdminSearchForm.get('guid').dirty) && (roleAdminSearchForm.get('guid').errors?.['pattern']) || (roleAdminSearchForm.get('guid').errors?.['invalidInputAsterisk'])"
              id="GUIDError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
              <ul>
                <li *ngIf="(roleAdminSearchForm.get('guid').errors?.['pattern'])">
                  {{'bss.roleAdminSearch.error.GUID.invalid' | translate }}
                </li>
                <li *ngIf="(roleAdminSearchForm.get('guid').errors?.['invalidInputAsterisk'])">
                  {{'bss.roleAdminSearch.error.Asterisk' | translate }}
                </li>
              </ul>
            </div>
          </div>
        </dd></dl>
      </div>

      <div class="ontario-row">
        <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-3">
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-9">
                <button tabindex="106" type="submit" (keyup.enter)="onSearch()" (click)="onSearch()" [style.cursor]="roleAdminSearchForm.valid ? 'pointer' : 'not-allowed'"
                aria-describedby="pageLevelMessageId" title="{{ (roleAdminSearchForm.valid ? 'bss.roleAdminSearch.button.search.title' : '') | translate }}"
                class="{{ (roleAdminSearchForm.valid) ? 'ontario-button ontario-button--primary' : 'ontario-button ontario-button--secondary' }}"
                [disabled]="roleAdminSearchForm.invalid || isSubmitting">
                {{'bss.roleAdminSearch.button.search' | translate }}
                </button>
            </div>
        </dd></dl>
      </div>
    </div>
</form>

<!--<div class="ontario-row">
  <div class="ontario-column ontario-small-12">
    <p>{{ 'bss.roleAdminSearch.resetWin.description' | translate}}</p>
    <button tabindex="107" (click)="onResetWin()" class="ontario-button ontario-button--primary"
        title="{{ 'bss.roleAdminSearch.button.resetWin.title' | translate }}">
        {{ 'bss.roleAdminSearch.button.resetWin' | translate }}
    </button>
  </div>
</div>
-->

<dialog class="ontario-progress" #progressDialog>

  <app-progress></app-progress>

</dialog>


